'use client';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Iconify } from 'src/components/iconify';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import { HJÄLTE } from '../landning-innehåll';

export const SPELA_FILM = 'flinky:spela-film';

export function Hjälte() {
    return (
        <Container component="section" maxWidth="lg" sx={{ pt: { xs: 8, md: 14 }, pb: { xs: 6, md: 10 } }}>
            <Box sx={{ maxWidth: 820 }}>
                <Typography
                    variant="h1"
                    sx={{
                        fontSize: { xs: '1.875rem', sm: '3rem', md: '3.5rem' },
                        hyphens: 'auto',
                        lineHeight: 1.12,
                        letterSpacing: '-0.02em',
                        textWrap: 'balance'
                    }}
                >
                    {HJÄLTE.rubrik}
                </Typography>
                <Typography
                    sx={{
                        mt: 3,
                        maxWidth: 640,
                        fontSize: { xs: '1.0625rem', md: '1.1875rem' },
                        lineHeight: 1.65,
                        color: 'text.secondary',
                        textWrap: 'pretty'
                    }}
                >
                    {HJÄLTE.ingress}
                </Typography>
                <Box sx={{ mt: 5, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5 }}>
                    <Button component={RouterLink} href={paths.REGISTRERA} variant="contained" color="primary" size="large">
                        {HJÄLTE.primär}
                    </Button>
                    <Button
                        href="#demo"
                        onClick={() => window.dispatchEvent(new CustomEvent(SPELA_FILM))}
                        variant="outlined"
                        color="inherit"
                        size="large"
                        startIcon={<Iconify icon="solar:play-circle-bold" />}
                    >
                        {HJÄLTE.sekundär}
                    </Button>
                </Box>
            </Box>
        </Container>
    );
}
